export default __webpack_public_path__ + "static/media/bg_gigabarians_hover.4f68565d.svg";